import {candidateApi, candidateApiMultipart, candidateApiWOContentType } from "../../../services/apiService";

export const getBasicDetails = () => {
  return candidateApi.get(`/profile/get-details`);
};

export const postBasicDetails = (payload) => {
  return candidateApi.post(`/profile/save-profile-details`, payload);
};

export const getAddressDetails = () => {
  return candidateApi.get(`/address/get-address`);
};

export const postAddressDetails = (payload) => {
  return candidateApi.post(`/address/save-address`, payload);
};

export const getEducationDetails = () => {
  return candidateApi.get(`/education/get-edu-details`);
};

export const postEducationDetails = (educationPayload, file, docCode) => {
  const formData = new FormData();
  if (file) {
    formData.append("file", file);
  }
  formData.append(
    "education",
    new Blob([JSON.stringify(educationPayload)], {
      type: "application/json",
    }),
  );
  return candidateApi.post(`/education/save-edu-details/${docCode}`, formData, {
    headers: {
      "X-Client": "candidate",
      "Content-Type": "multipart/form-data",
    },
  });
};

export const deleteEducationDetails = (educationId) => {
  if (!educationId) {
    throw new Error("educationId is required");
  }
  return candidateApi.delete(`/education/delete-edu-details`, {
    params: { educationId },
    headers: {
      "X-Client": "candidate",
    },
  });
};

export const getExperienceDetails = () => {
  return candidateApi.get(`/experience/get-exp-details`);
};

export const postExperienceDetails = (workExperiencePayload, file) => {
  const formData = new FormData();

  if (file) {
    formData.append("file", file);
  }
  formData.append(
    "workExperience",
    new Blob([JSON.stringify(workExperiencePayload)], {
      type: "application/json",
    }),
  );

  return candidateApi.post(`/experience/save-exp-details`, formData, {
    headers: {
      "X-Client": "candidate",
      "Content-Type": "multipart/form-data",
    },
  });
};

export const deleteExperienceDetails = (workExperienceId) => {
  return candidateApi.delete(`/experience/delete-exp/${workExperienceId}`, {
    headers: {
      "X-Client": "candidate",
    },
  });
};

export const getDocumentDetails = () => {
  return candidateApi.get(`/documents/get-doc`);
};

export const getDocumentDetailsByCode = (docCode) => {
  return candidateApi.get(`/documents/get-doc-by-doccode/${docCode}`);
};

export const postDocumentDetails = (
  documentId,
  file,
  isOther,
  documentName,
  isValidationPending = null,
  pendingChecks = [],
) => {
  if (!file) {
    throw new Error("Document file is required");
  }

  if (isOther && !documentName) {
    throw new Error("Document Name is required");
  }

  const formData = new FormData();

  formData.append("file", file);

  const requestPayload = {};

  if (isValidationPending !== null) {
    requestPayload.isValidationPending = isValidationPending;
  }

  if (pendingChecks && pendingChecks.length > 0) {
    requestPayload.pendingChecks = pendingChecks;
  }
  formData.append(
    "request",
    new Blob([JSON.stringify(requestPayload)], {
      type: "application/json",
    }),
  );

  let url = isOther
    ? `/documents/upload-other/${documentName}`
    : `/documents/upload-document/${documentId}`;

  return candidateApiWOContentType.post(url, formData, {
    headers: {
      "X-Client": "candidate",
    },
  });
};

export const ValidateDocument = (docCode, file) => {
  if (!file) {
    throw new Error("Document file is required");
  }
  if (!docCode) {
    throw new Error("Document Name is required");
  }

  const formData = new FormData();
  formData.append("file", file); // key name MUST match backend
  const Url = `/validate-document/validate-document/${docCode}`;
  return candidateApi.post(Url, formData, {
    headers: {
      "X-Client": "candidate",
      "Content-Type": "multipart/form-data",
    },
  });
};

export const deleteDocument = (documentId) => {
  if (!documentId) {
    throw new Error("documentId is required");
  }

  return candidateApi.delete(`/documents/delete-doc/${documentId}`, {
    headers: {
      "X-Client": "candidate",
    },
  });
};

export const parseResumeDetails = (resumeFile) => {
  const formData = new FormData();
  formData.append("resume", resumeFile);

  return candidateApi.post(`/resume/upload`, formData, {
    headers: {
      "X-Client": "candidate",
      "Content-Type": "multipart/form-data",
    },
  });
};

export const getResumeDetails = () => {
  return candidateApi.get(`/resume/get-resume-details`);
};

export const saveAllExperienceDetails = (experiencePayload) => {
  return candidateApi.post(
    `/experience/save-all-exp-details`,
    experiencePayload,
    {
      headers: {
        "X-Client": "candidate",
      },
    },
  );
};

export const getWorkStatus = () => {
  return candidateApi.get(`/profile/get-work-status`, {
    headers: {
      "X-Client": "candidate",
    },
  });
};

export const postWorkStatus = (isFresher) => {
  return candidateApi.post(`/profile/save-work-status`, null, {
    params: { isFresher: isFresher }, //  backend expects QUERY param
    headers: {
      "X-Client": "candidate",
    },
  });
};

export const saveProfileComplete = (isProfileCompleted = true) => {
  return candidateApi.post(`/candidate/save-profile-complete`, null, {
    params: { isProfileCompleted },
    headers: {
      "X-Client": "candidate",
    },
  });
};

export const getHasCertification = () => {
  return candidateApi.get(`/certifications/get-has-cert`, {
    headers: {
      "X-Client": "candidate",
    },
  });
};

export const saveHasCertification = (hasCertification) => {
  return candidateApi.post(`/certifications/save-has-cert`, null, {
    params: { hasCertification },
    headers: {
      "X-Client": "candidate",
    },
  });
};

export const saveCertification = (certificationPayload, file) => {
  const formData = new FormData();
  if (file) {
    formData.append("file", file);
  }
  formData.append(
    "certificationsDTO",
    new Blob([JSON.stringify(certificationPayload)], {
      type: "application/json",
    }),
  );

  return candidateApi.post(`/certifications/save-cert-details`, formData, {
    headers: {
      "X-Client": "candidate",
      "Content-Type": "multipart/form-data",
    },
  });
};

export const getCertifications = () => {
  return candidateApi.get(`/certifications/get-cert-details`, {
    headers: {
      "X-Client": "candidate",
    },
  });
};

export const deleteCertification = (certificationId) => {
  if (!certificationId) {
    throw new Error("certificationId is required");
  }

  return candidateApi.delete(
    `/certifications/delete-cert-details/${certificationId}`,
    {
      headers: {
        "X-Client": "candidate",
      },
    },
  );
};

export const validateCertification = (certificationId, file) => {
  if (!file) {
    throw new Error("Document file is required");
  }
  if (!certificationId) {
    throw new Error("certificationId is required");
  }

  const formData = new FormData();
  formData.append("file", file);

  return candidateApiMultipart.post(
    `/validate-certification/validate/${certificationId}`,
    formData,
    {
      headers: {
        "X-Client": "candidate",
      },
    },
  );
};

export const uploadIdProof = (
  documentId,
  documentNumber,
  file,
  isValidationPending = false,
  pendingChecks = [],
) => {
  const formData = new FormData();
  formData.append("file", file);
  const requestPayload = {
    documentId,
    documentNumber,
  };

  if (isValidationPending) {
    requestPayload.isValidationPending = true;
    requestPayload.pendingChecks = pendingChecks;
  } else {
    requestPayload.isValidationPending = false;
  }

  formData.append(
    "request",
    new Blob([JSON.stringify(requestPayload)], {
      type: "application/json",
    }),
  );

  return candidateApiWOContentType.post(`/documents/upload-idproof`, formData, {
    headers: {
      "X-Client": "candidate",
    },
  });
};
export const validateIdProof = (documentId, documentNumber, file) => {
  const formData = new FormData();

  formData.append("file", file);

  formData.append(
    "request",
    new Blob(
      [
        JSON.stringify({
          documentId,
          documentNumber,
        }),
      ],
      {
        type: "application/json",
      },
    ),
  );

  return candidateApi.post(
    "/validate-document/validate-id-proof-document",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
        "X-Client": "candidate",
      },
    },
  );
};

const validateBirthDateProof = (file, requestPayload) => {
  const formData = new FormData();

  formData.append("file", file);

  formData.append(
    "request",
    new Blob([JSON.stringify(requestPayload)], {
      type: "application/json",
    }),
  );

  return candidateApi.post(
    "/validate-document/validate-birthdate-proof-document",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
        "X-Client": "candidate",
      },
    },
  );
};

export const validateWorkExperienceDocument = (payload, file) => {
  const formData = new FormData();

  formData.append("file", file);

  formData.append(
    "request",
    new Blob([JSON.stringify(payload)], {
      type: "application/json",
    }),
  );

  return candidateApiMultipart.post(
    "/validate-document/validate-work-exp-document",
    formData,
  );
};

export const initializeDigiLocker = () => {
  return candidateApi.get("/digilocker/init", {
    headers: {
      "X-Client": "candidate",
    },
  });
};

export const initializeDigiLockerConsent = async (
  flowType = "issued",
  docCode,
  pageNo,
) => {
   try {

    console.log("pageNo =>", pageNo);
    console.log("flowType =>", flowType);
    console.log("docCode =>", docCode);
  const response = await candidateApi.get("/digilocker/init", {
    params: {
      flowType,
      docCode,
      pageNo,
    },
    headers: {
      "X-Client": "candidate",
    },
  });

  return {
    success: true,
    data: response.data,
    redirectUrl:
      response.data?.redirectUrl ||
      response.data?.data?.redirectUrl ||
      response.data?.url,
  };
    } catch (err) {
    console.error("Failed to initialize DigiLocker consent", err);

    return {
      success: false,
      error: err,
    };
  }
};
const profileApi = {
  getBasicDetails,
  postBasicDetails,
  getAddressDetails,
  postAddressDetails,
  getEducationDetails,
  postEducationDetails,
  deleteEducationDetails,
  getExperienceDetails,
  postExperienceDetails,
  deleteExperienceDetails,
  getDocumentDetails,
  getDocumentDetailsByCode,
  postDocumentDetails,
  deleteDocument,
  parseResumeDetails,
  getResumeDetails,
  saveAllExperienceDetails,
  getWorkStatus,
  postWorkStatus,
  ValidateDocument,
  saveProfileComplete,
  getHasCertification,
  saveHasCertification,
  saveCertification,
  getCertifications,
  deleteCertification,
  validateCertification,
  uploadIdProof,
  validateIdProof,
  validateBirthDateProof,
  validateWorkExperienceDocument,
  initializeDigiLocker,
  initializeDigiLockerConsent,
};
export default profileApi;